// App Info
export const APP_NAME = 'Stil Perde';
export const APP_VERSION = '1.4.0';

// Firebase Configuration
// YENİ FİREBASE PROJESİ İÇİN DEĞERLERİ BURAYA GİRİN
// Firebase Console > Project Settings > Your apps > Web app config değerlerini buraya kopyalayın
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBr9f--dTlzqXoeyTvTgKSxVmGHzJHgbK8",
  authDomain: "stil-perde.firebaseapp.com",
  projectId: "stil-perde",
  storageBucket: "stil-perde.firebasestorage.app",
  messagingSenderId: "554063495048",
  appId: "1:554063495048:web:47212c87c8f17d562b043d",
  measurementId: "G-J8YRWVT8JYD"
};

// App Colors
export const COLORS = {
  primary: '#1a1a1a',
  primaryHover: '#000000',
  secondary: '#f5f5f5',
  success: '#4caf50',
  error: '#f44336',
  warning: '#ff9800',
  info: '#2196f3',
  text: '#333',
  textLight: '#666',
  border: '#e1e5e9'
};

// Product Types
export const PRODUCT_TYPES = {
  tul: {
    label: 'Tül',
    fields: ['roomName', 'productName', 'width', 'height', 'pileModel', 'pileDensity', 'usedM2', 'unitPrice', 'extraPrice', 'capsuleUnitPrice', 'capsulePrice', 'hasAltEtekKatlama', 'altEtekKatlamaAmount', 'altEtekKatlamaCostAmount', 'accessories', 'kanatAccessories', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      // Bu fonksiyon daha sonra detaylı hesaplamalar için kullanılacak
      return 0;
    }
  },
  kanat: {
    label: 'Kanat',
    fields: ['roomName', 'productName', 'width', 'height', 'pileModel', 'pileDensity', 'usedM2', 'unitPrice', 'extraPrice', 'capsuleUnitPrice', 'capsulePrice', 'accessories', 'kanatAccessories', 'hasOzelTasarim', 'ozelTasarimProductName', 'ozelTasarimProductVariant', 'ozelTasarimWidth', 'ozelTasarimHeight', 'ozelTasarimUnitPrice', 'ozelTasarimUnitCost', 'ozelTasarimBaseUnitPrice', 'ozelTasarimBaseUnitCost', 'ozelTasarimPileModel', 'ozelTasarimPileDensity', 'ozelTasarimUsedM2', 'ozelTasarimExtraPrice', 'ozelTasarimQuantity', 'ozelTasarimTotalPrice', 'hasAstar', 'astarProductName', 'astarProductVariant', 'astarUnitPrice', 'astarUnitCost', 'astarPrice', 'astarCost', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  stor: {
    label: 'Stor',
    fields: ['roomName', 'productName', 'direction', 'width', 'height', 'usedM2', 'unitPrice', 'jumboSystem', 'reductor', 'bottomSkirt', 'closedCase', 'laser', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  zebra: {
    label: 'Zebra',
    fields: ['roomName', 'productName', 'direction', 'width', 'height', 'usedM2', 'unitPrice', 'jumboSystem', 'reductor', 'bottomSkirt', 'closedCase', 'laser', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  ahsapJaluzi: {
    label: 'Ahşap Jaluzi',
    fields: ['roomName', 'productName', 'direction', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'hasZigil', 'hasReduktor', 'hasKurdela', 'zigilAmount', 'width', 'height', 'usedM2', 'sistemTipi', 'unitPrice', 'mounting', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  metalJaluzi: {
    label: 'Metal Jaluzi',
    fields: ['roomName', 'productName', 'direction', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'hasMetalZigil', 'hasMetalReduktor', 'hasIkiCamArasi', 'metalZigilAmount', 'ikiCamArasiAmount', 'width', 'height', 'usedM2', 'unitPrice', 'mounting', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyPerde: {
    label: 'Dikey Perde',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'hasDikeyFon', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyPvc: {
    label: 'Dikey PVC',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  dikeyStor: {
    label: 'Dikey Stor',
    fields: ['roomName', 'productName', 'width', 'height', 'direction', 'usedM2', 'unitPrice', 'mounting', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  plise: {
    label: 'Plise',
    fields: ['roomName', 'pliseProduct1Name', 'pliseProduct1Price', 'pliseProduct1Variation', 'pliseProduct2Name', 'pliseProduct2Price', 'pliseProduct2Variation', 'width', 'height', 'usedM2', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice', 'notes'],
    calculations: (data) => {
      return 0;
    }
  },
  katlamaliPerde: {
    label: 'Katlamalı Perde',
    fields: ['roomName', 'productName', 'width', 'height', 'usedM2', 'fabricPrice', 'mechanismType', 'mechanismPrice', 'accessoryPrice', 'motorType', 'motorPrice', 'motorPriceCurrency', 'motorCost', 'motorCostCurrency', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice'],
    calculations: (data) => {
      return 0;
    }
  },
  raySistemi: {
    label: 'Ray Sistemleri',
    fields: ['roomName', 'productName', 'width', 'olcuTamamlama', 'usedMeter', 'unitPrice', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice', 'notes'],
    calculations: (data) => {
      return 0;
    }
  },
  rustik: {
    label: 'Rustik',
    fields: ['roomName', 'productName', 'width', 'unitPrice', 'usedCm', 'ayakModel', 'ayakCap', 'ayakUzunluk', 'ayakRenkKodu', 'ayakSayisi', 'ekAyakSayisi', 'ayakUcreti', 'mounting', 'quantity', 'discount', 'totalPrice', 'discountedPrice', 'notes', 'rustikAksesuarlar', 'rustikRaySecenekleri'],
    calculations: (data) => {
      return 0;
    }
  },
  aksesuar: {
    label: 'Aksesuar',
    fields: ['roomName', 'productName', 'quantity', 'unitPrice'],
    calculations: (data) => {
      return 0;
    }
  }
};

// Ahşap ve Metal Jaluzi Sistem Tipleri
export const JALUZI_SISTEM_TIPLERI = {
  merdivenIpli: 'Merdiven İpli',
  kurdeleli: 'Kurdeleli',
  merdivenIpliReduktorlu: 'Merdiven İpli Redüktörlü',
  kurdelaliReduktorlu: 'Kurdelalı Redüktörlü'
};

// Yön Tipleri
export const DIRECTION_TYPES = {
  LEFT: 'Sol',
  RIGHT: 'Sağ'
};

// Dikey Ürün Yön Tipleri
export const DIKEY_DIRECTION_TYPES = {
  SAGA: 'Sağa açılım',
  SOLA: 'Sola açılım',
  ORTADAN: 'Ortadan açılım'
};

// Motor Tipleri
export const MOTOR_TYPES = {
  MOTOR_1: 'Motor',
  MOTOR_2_KUMANDA: 'Motor + Kumanda'
};


// Tül ve Kanat Pile Modelleri
export const TUL_PILE_MODELS = {
  standartSeyrek: 'Standart SEYREK',
  standartOrta: 'Standart ORTA',
  standartSik: 'Standart SIK',
  sPile: 'S Pile',
  amerikanPile2li: 'Amerikan Pile 2\'li',
  amerikanPile3lu: 'Amerikan Pile 3\'lü',
  kapsulPile: 'Kapsül Pile',
  cimaDikis: 'Çima Dikiş',
  duzDikis: 'Düz Dikiş',
  kumasGuneslik: 'Kumaş Güneşlik'
};

// Kanat Pile Modelleri (Tül ile aynı)
export const KANAT_PILE_MODELS = {
  standartSeyrek: 'Standart SEYREK',
  standartOrta: 'Standart ORTA',
  standartSik: 'Standart SIK',
  sPile: 'S Pile',
  amerikanPile2li: 'Amerikan Pile 2\'li',
  amerikanPile3lu: 'Amerikan Pile 3\'lü',
  kapsulPile: 'Kapsül Pile',
  cimaDikis: 'Çima Dikiş',
  duzDikis: 'Düz Dikiş',
  kumasGuneslik: 'Kumaş Güneşlik'
};

// Pile Sıklığı Değerleri
export const PILE_DENSITY_VALUES = {
  standartSeyrek: 2,
  standartOrta: 2.5,
  standartSik: 3,
  sPile: 3,
  amerikanPile2li: 3,
  amerikanPile3lu: 4,
  kapsulPile: 3
};

// Routes
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  LOGIN: '/'
};

// Notification Types
export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};

// Local Storage Keys
export const STORAGE_KEYS = {
  USER_SESSION: 'user_session',
  THEME: 'theme'
};

// Order Status Types
export const ORDER_STATUS = {
  NEW_ORDER: 'new_order',
  FIRMA: 'firma',
  ATOLYE: 'atolye',
  MONTAJ: 'montaj',
  DELIVERED: 'delivered'
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUS.NEW_ORDER]: 'Yeni Sipariş',
  [ORDER_STATUS.FIRMA]: 'Firma',
  [ORDER_STATUS.ATOLYE]: 'Atölye',
  [ORDER_STATUS.MONTAJ]: 'Montaj',
  [ORDER_STATUS.DELIVERED]: 'Teslim Edildi'
};

// Pagination Options
export const PAGINATION_OPTIONS = [5, 10, 15, 20, 25, 50, 100];

// Ödeme Tipleri
export const PAYMENT_TYPES = {
  CASH: 'cash',
  IBAN: 'iban',
  CREDIT_CARD: 'credit_card'
};

export const PAYMENT_TYPE_LABELS = {
  [PAYMENT_TYPES.CASH]: 'Elden Nakit',
  [PAYMENT_TYPES.IBAN]: 'IBAN',
  [PAYMENT_TYPES.CREDIT_CARD]: 'Kredi Kartı'
};

// WhatsApp Firma Listesi
export const WHATSAPP_FIRMA_LIST = [
  {
    id: 1,
    name: "Besa",
    phone: "905323992248",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 2,
    name: "By perdeci",
    phone: "905362111565",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 3,
    name: "Çankaya",
    phone: "905052636976",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 4,
    name: "DRN",
    phone: "905449151522",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 5,
    name: "Farbe",
    phone: "905357884885",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 6,
    name: "Hometex",
    phone: "905392721472",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 7,
    name: "Lilium",
    phone: "905373123081",
    defaultMessage: "Merhaba, sipariş detayları aşağıdaki gibidir:"
  },
  {
    id: 8,
    name: "Moss",
    phone: "905455166316",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 9,
    name: "Mysia",
    phone: "905339386947",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 10,
    name: "Perdelotti",
    phone: "905060995616",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 11,
    name: "Tüzemen",
    phone: "905397810632",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 12,
    name: "Yıldız Stor",
    phone: "905493608887",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 13,
    name: "İsmail Şengil",
    phone: "905349458135",
    defaultMessage: "Yeni sipariş bilgileri:"
  },
  {
    id: 14,
    name: "Gülsüm Şengil",
    phone: "905312079547",
    defaultMessage: "Yeni sipariş bilgileri:"
  }
]; 